const isPasswordFormatValid = (passwordToTest) => {
  const passwordRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  return passwordRegex.test(passwordToTest);
};

const isPhoneFormatValid = (phoneNumber) => {
  const phoneRegex = new RegExp("^(([0-9]{3}) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$");
  return phoneRegex.test(phoneNumber);
};

const isEmailFormatValid = (email) => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

const isDobFormatValid = (dob) => {
  const dobRegex = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/;
  return dobRegex.test(dob);
};

export {
  isPhoneFormatValid,
  isPasswordFormatValid,
  isEmailFormatValid,
  isDobFormatValid,
};
